import { useMemo } from 'react';
export function computeEditFooterMatrix(_a) {
    var event_permissions = _a.event_permissions, isPastEvent = _a.isPastEvent, isRobinEvent = _a.isRobinEvent, canEditSyncedEvents = _a.canEditSyncedEvents, hasEventsManagePermission = _a.hasEventsManagePermission, isRedirectingToOldComposer = _a.isRedirectingToOldComposer;
    var userHasUpdatePermission = !!(event_permissions === null || event_permissions === void 0 ? void 0 : event_permissions.update);
    var notRobinEventAndCannotEditSynced = !isRobinEvent && !canEditSyncedEvents;
    var isEventEditable = !isPastEvent && !notRobinEventAndCannotEditSynced;
    var updateAsSpace = !!(event_permissions === null || event_permissions === void 0 ? void 0 : event_permissions.update_as_space);
    var noEditPermission = !userHasUpdatePermission && !updateAsSpace;
    var isEditButtonDisabled = isRedirectingToOldComposer || !isEventEditable || noEditPermission;
    var userHasDeletePermission = !!(event_permissions === null || event_permissions === void 0 ? void 0 : event_permissions.cancel);
    var noUserDeletePermissionAndNoManagePermission = !userHasDeletePermission && !hasEventsManagePermission;
    var isDeletableEvent = !notRobinEventAndCannotEditSynced;
    var deleteAsSpace = !!(event_permissions === null || event_permissions === void 0 ? void 0 : event_permissions.remove_space);
    var isDeleteButtonDisabled = isRedirectingToOldComposer ||
        !isDeletableEvent ||
        (!deleteAsSpace && !userHasDeletePermission);
    var primaryEditDisabledReason = !isEditButtonDisabled
        ? null
        : isRedirectingToOldComposer
            ? 'isRedirectingToOldComposer'
            : isPastEvent
                ? 'pastEvent'
                : notRobinEventAndCannotEditSynced
                    ? 'notRobinEventAndCannotEditSynced'
                    : noEditPermission
                        ? 'noUserPermissionAndNoManagePermission'
                        : null;
    var primaryCancelDisabledReason = !isDeleteButtonDisabled
        ? null
        : isRedirectingToOldComposer
            ? 'isRedirectingToOldComposer'
            : noUserDeletePermissionAndNoManagePermission
                ? 'noUserPermissionAndNoManagePermission'
                : null;
    return {
        updateAsSpace: updateAsSpace,
        isEditButtonDisabled: isEditButtonDisabled,
        deleteAsSpace: deleteAsSpace,
        isDeleteButtonDisabled: isDeleteButtonDisabled,
        isPastEvent: isPastEvent,
        notRobinEventAndCannotEditSynced: notRobinEventAndCannotEditSynced,
        noEditPermission: noEditPermission,
        primaryEditDisabledReason: primaryEditDisabledReason,
        primaryCancelDisabledReason: primaryCancelDisabledReason,
    };
}
export function useEditFooterMatrix(params) {
    var event_permissions = params.event_permissions, isPastEvent = params.isPastEvent, isRobinEvent = params.isRobinEvent, canEditSyncedEvents = params.canEditSyncedEvents, hasEventsManagePermission = params.hasEventsManagePermission, isRedirectingToOldComposer = params.isRedirectingToOldComposer;
    return useMemo(function () {
        return computeEditFooterMatrix({
            event_permissions: event_permissions,
            isPastEvent: isPastEvent,
            isRobinEvent: isRobinEvent,
            canEditSyncedEvents: canEditSyncedEvents,
            hasEventsManagePermission: hasEventsManagePermission,
            isRedirectingToOldComposer: isRedirectingToOldComposer,
        });
    }, [
        event_permissions,
        isPastEvent,
        isRobinEvent,
        canEditSyncedEvents,
        hasEventsManagePermission,
        isRedirectingToOldComposer,
    ]);
}
